$(document).ajaxSend(function () {
  if (window.ajax_start_timestamps == null) {
    window.ajax_start_timestamps = [];
  }
  if (window.ajax_start_sequence == null) {
    window.ajax_start_sequence = parseInt(
      window.sessionStorage.getItem('ajax_start_sequence') || '0',
      10
    );
  }
  window.ajax_start_sequence += 1;
  window.sessionStorage.setItem(
    'ajax_start_sequence',
    window.ajax_start_sequence
  );
  window.ajax_start_timestamps.push(Date.now() / 1000);
});
